// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__hWrOD","lds-ring":"styles_lds-ring__ZNsAT"};